import React, { Component } from "react";

class Unauthorized extends Component {
    render() {
        return (
            <section className="login">
                <div className="unauthorized">
                    <div>close !</div>
                    <p>
                        <span>erro 401 !</span> parece que voce nao deveria estar aqui
                    </p>
                </div>
            </section>
        );
    }
}

export default Unauthorized;
